import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Close = function Close(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.62109 18.6141C3.09473 19.1405 3.08398 20.0751 3.63184 20.6229C4.19043 21.1708 5.125 21.16 5.64062 20.6444L12 14.285L18.3486 20.6337C18.8857 21.1708 19.8096 21.1708 20.3574 20.6229C20.9053 20.0643 20.9053 19.1513 20.3682 18.6141L14.0195 12.2655L20.3682 5.90614C20.9053 5.36903 20.916 4.4452 20.3574 3.89735C19.8096 3.3495 18.8857 3.3495 18.3486 3.88661L12 10.2352L5.64062 3.88661C5.125 3.36024 4.17969 3.33876 3.63184 3.89735C3.08398 4.4452 3.09473 5.39051 3.62109 5.90614L9.96973 12.2655L3.62109 18.6141Z"
  })));
};

Close.displayName = 'Close';
export default Close;